import { render, staticRenderFns } from "./handbook-page.vue?vue&type=template&id=7585c69e&scoped=true"
import script from "./handbook-page.vue?vue&type=script&lang=js"
export * from "./handbook-page.vue?vue&type=script&lang=js"
import style0 from "./handbook-page.vue?vue&type=style&index=0&id=7585c69e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7585c69e",
  null
  
)

export default component.exports